import Bulb from './Bulb';

export default Bulb;